import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library.js';
/**
 * Icon element, used for non-clickable icons
 *
 * @prop {String} icon - used to define a Fontawesome icon
 * @prop {Number} size - used to define a specific size for the icon (default is 20)
 * @prop {Boolean} light - used to display the icon in the light color (default white)

 *
 */
let SDBContentIcon = class SDBContentIcon extends LitElement {
    constructor() {
        super();
        this.icon = '';
        this.size = 20;
        this.light = false;
        registerIconLibrary('fal', {
            resolver: name => {
                return ('https://cdn.sdbleerplatform.nl/svgs/light/' + name + '.svg');
            },
        });
        registerIconLibrary('brands', {
            resolver: name => {
                return ('https://cdn.sdbleerplatform.nl/svgs/brands/' +
                    name +
                    '.svg');
            },
        });
        registerIconLibrary('heart', {
            resolver: name => {
                return ('https://cdn.sdbleerplatform.nl/svgs/hearts/' +
                    name +
                    '.svg');
            },
        });
    }
    render() {
        if (!this.iconname)
            return html ``;
        return html `
            <sl-icon
                library="${this.iconset}"
                name="${this.iconname}"
                style="font-size: ${this.size}px"
            ></sl-icon>
        `;
    }
    get iconset() {
        if (!this.icon)
            return;
        const icons = this.icon.split(' ');
        return icons[0];
    }
    get iconname() {
        if (!this.icon)
            return;
        const icons = this.icon.split(' ');
        return icons[1].replace('fa-', '');
    }
};
SDBContentIcon.styles = [
    elements,
    css `
            :host {
                display: inline-flex;
            }

            :host([light]) {
                /* TODO: double-check behavior */
                color: var(--text-light);
            }

            sl-icon {
                pointer-events: none;
                fill: var(--fa-icon-fill-color, currentcolor);
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentIcon.prototype, "icon", void 0);
__decorate([
    property({ type: Number })
], SDBContentIcon.prototype, "size", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentIcon.prototype, "light", void 0);
SDBContentIcon = __decorate([
    customElement('sdb-content-icon')
], SDBContentIcon);
export { SDBContentIcon };
//# sourceMappingURL=sdb-content-icon.js.map